/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserName } from './userName';
import { TreatmentTopic } from './treatmentTopic';
import { Practice } from './practice';
import { TreatmentApproach } from './treatmentApproach';


import {ValidatorFn, Validators} from "@angular/forms";

export interface UserTherapistProfile { 
    readonly id: number;
    readonly associatedUsers: Array<UserName>;
    readonly practices: Array<Practice>;
    readonly treatmentApproaches: Array<TreatmentApproach>;
    readonly treatmentTopics: Array<TreatmentTopic>;
    readonly blacklistedTreatmentTopics: Array<TreatmentTopic>;
    readonly signatureUrl: string | null;
}
export const UserTherapistProfile_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserTherapistProfile_associatedUsers_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserTherapistProfile_practices_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserTherapistProfile_treatmentApproaches_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserTherapistProfile_treatmentTopics_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserTherapistProfile_blacklistedTreatmentTopics_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserTherapistProfile_signatureUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];


